import(/* webpackMode: "eager" */ "/codebuild/output/src1650488179/src/app/error.tsx");
